import { render, staticRenderFns } from "./PagePath.vue?vue&type=template&id=171f137c&scoped=true"
import script from "./PagePath.vue?vue&type=script&setup=true&lang=js"
export * from "./PagePath.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PagePath.vue?vue&type=style&index=0&id=171f137c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171f137c",
  null
  
)

export default component.exports